import { EntityType } from '@frontend/common';
import { deceasedRequest } from '@frontend/deceased/events';
import { IDeceased } from '@frontend/deceased/types';
import { ObjectBadge, ObjectBadgeProps } from '@frontend/rendering/badge';
import React from 'react';

export const DeceasedBadge = (props: ObjectBadgeProps<IDeceased>) => {
    return (
        <ObjectBadge<IDeceased>
            id={props.id}
            type={EntityType.DECEASED}
            mapDisplayName={(deceased: IDeceased) => deceased.name}
            resolve={deceasedRequest}
            key={props.id}
            navigateString={(object: IDeceased) => `/accounts/${object.account_id}/deceased/${object.id}`}
            {...props}
        />
    );
};
